import script from "./StepTenant.vue?vue&type=script&setup=true&lang=js"
export * from "./StepTenant.vue?vue&type=script&setup=true&lang=js"

import "./StepTenant.vue?vue&type=style&index=0&id=ce814ca2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce814ca2"]])

export default __exports__